import { computed } from "vue";
import { useAuthStore } from "@/stores/auth";

export function useMemberPersonId() {
  const auth = useAuthStore();
  return computed(() => {
    if (!auth.isAuthenticated()) return null;
    const id = Number(auth.accessToken?.claims.sub);
    return Number.isSafeInteger(id) && id > 0 ? id : null;
  });
}
